import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import API from "../../utils/api"; // Uvozimo API instancu
import "./ForgotPassword.css"; // Dodaj odgovarajuće CSS stilove

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error("Unesite email adresu!");
      return;
    }

    try {
      setLoading(true);

      // 🟢 Axios API poziv
      const { data } = await API.post("/auth/forgot-password", { email });

      toast.success(data.message || "Proverite email za reset lozinke!");
    } catch (error) {
      toast.error(error.response?.data?.message || "Neuspešno slanje zahteva!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="sd__wrapper">
      {/* Notifikacije */}
      <ToastContainer position="top-right" autoClose={3000} />

      {/* Logo */}
      <div className="sd__logo">
        <img
          src={require("../../assets/images/sdicon.png")}
          alt="SmartDeal Logo"
        />
      </div>

      {/* Naslov */}
      <div className="sd__title">Resetovanje lozinke</div>

      {/* Forma */}
      <form className="sd__form" onSubmit={handleSubmit}>
        <div className="sd__form-field">
          <input
            type="email"
            name="email"
            id="email"
            placeholder="Unesite vaš email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <button className="sd__btn" type="submit" disabled={loading}>
          {loading ? "Šalje se..." : "Pošalji zahtev"}
        </button>
      </form>

      {/* Linkovi */}
      <div className="sd__links">
        <Link to="/login">Povratak na prijavu</Link> |{" "}
        <Link to="/register">Registracija</Link>
      </div>
    </div>
  );
};

export default ForgotPassword;
